import IComponent from "components/commons/IComponent";
import "./RainfallChart.scoped.css";
import moment from "moment";
import Xml2Json from "utils/Xml2Json";
import ReactECharts from "echarts-for-react";
import SwitchTabs from "components/commons/SwitchTabs";
import DivTable from "components/commons/DivTable";
import DownloadBlob from "utils/DownloadBlob";
const CHART_OPTIONS = {
  title: {
    left: "center",
  },
  tooltip: {
    show: true,
    trigger: "axis",
    formatter: "{c}<br/>{b}",
  },
  xAxis: {
    type: "category",
    name: "(mm)",
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: [],
      type: "line",
      itemStyle: {
        color: "#FF0000",
      },
    },
  ],
};
const DATE_FORMAT = "DD/MM/YYYY HH:mm:ss";
const DATE_FORMAT_QUERY = "DD-MM-YYYY HH:mm:ss";
const REQUEST_XML_TEMPLATE =
  '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">    <soap:Body>        <Rainfall_By_Raingauge xmlns="http://tempuri.org/">            <pPassword>password01</pPassword>            <pRaingauge>{$raingauge_id}</pRaingauge>            <pDateTo>{$datetime}</pDateTo>            <pDurationInHour>24</pDurationInHour>        </Rainfall_By_Raingauge>    </soap:Body></soap:Envelope>';
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      dateTime: undefined,
    };
  }
  componentDidMount() {
    this.fetchGaugeInfo();
  }
  async fetchGaugeInfo() {
    window.moment = moment;
    let queryTime = Date.now();
    queryTime -= queryTime % (1000 * 60 * 5);
    queryTime = moment(queryTime).format(DATE_FORMAT_QUERY);
    let xmlContent = REQUEST_XML_TEMPLATE.replace(
      "{$raingauge_id}",
      this.props.raingauge
    ).replace("{$datetime}", queryTime);
    let result = await this.fetchQueryMain(
      "https://georainsys.cedd.gov.hk/CEDD/mGInfo/Raingauges/server.php",
      "POST",
      xmlContent,
      {
        headers: {
          Soapaction: "http://tempuri.org/Rainfall_By_Raingauge",
        },
      },
      "text/xml; charset=UTF-8"
    );
    result = await result.text();
    result = Xml2Json(result);
    this.transformToChart(result);
  }
  transformToChart(result) {
    result =
      result["soap:Envelope"]["soap:Body"]["Rainfall_By_RaingaugeResponse"][
        "Rainfall_By_RaingaugeResult"
      ];

    let accumulated = 0;
    let array = Object.values(result).map((i) => [
      moment(i.RainfallDate, DATE_FORMAT).toDate(),
      parseFloat(i.Final_Rainfall),
      (accumulated += parseFloat(i.Final_Rainfall)),
    ]);
    array.sort((a, b) => a - b);
    let tableData = array;
    let dateTime = array.map((i) => moment(i[0]).format(DATE_FORMAT));
    let timeData = array.map((i) => i[1]);
    let accumlated = array.map((i) => i[2]);
    this.setState({
      tableData,
      dateTime,
      timeData,
      accumlated,
    });
  }
  getChartOptions(title, data) {
    let options = JSON.parse(JSON.stringify(CHART_OPTIONS));
    options.title.text = title;
    options.xAxis.data = this.state.dateTime;
    options.series[0].data = data;
    return options;
  }

  exportRainfallCsv() {
    let sb = ["Date,Rainfall (mm),Accumulated Rainfall (mm)"];
    this.state.tableData.forEach((i) => {
      sb.push(`${moment(i[0]).format(DATE_FORMAT)},${i[1]},${i[2]}`);
    });
    DownloadBlob(sb.join("\r\n"), "Rainfall.csv", "text/csv", false);
  }

  render() {
    return (
      <div className="ChartsContainer">
        {!this.state.dateTime && (
          <div className="SubPanelContent AlignCentre">
            <span className="icn_loading" />
            Loading the rain gauge data...
          </div>
        )}
        {this.state.dateTime && (
          <SwitchTabs tabText={["Chart", "Table"]} style={{ height: "100%" }}>
            <div style={{ height: "100%" }}>
              <ReactECharts
                option={this.getChartOptions(
                  "24-hour rainfall",
                  this.state.timeData
                )}
              />
              <ReactECharts
                option={this.getChartOptions(
                  "24-hour rainfall (Cumulative)",
                  this.state.accumlated
                )}
              />
            </div>
            <div
              className="EqualWidthChildren column"
              style={{ height: "100%" }}
            >
              <div className="ChartTableContainer">
                <DivTable
                  data={this.state.tableData}
                  columnDef={[
                    {
                      name: "Date Time",
                      value: 0,
                      width: "100px",
                      format: (value, row) => moment(value).format(DATE_FORMAT),
                    },
                    {
                      name: "Rainfall (mm)",
                      value: 1,
                    },
                    {
                      name: "Accumulated Rainfall (mm)",
                      value: 2,
                    },
                  ]}
                />
              </div>
              <div className="ChartTableDownloadBar">
                <span
                  className="ActionBtn icn_3d_Elevationprofile_export"
                  onClick={() => this.exportRainfallCsv()}
                />
              </div>
            </div>
          </SwitchTabs>
        )}
      </div>
    );
  }
}

export default ClassName;
